const isMainNavEnabled = false;
export default [
  {
    path: 'home',
    name: 'Home',
    component: () => import(/* webpackChunkName: "aspportal-home" */ '../views/Home.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'programoverview',
    name: 'Program Overview',
    component: () => import('../views/programoverview.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'aspdetails',
    name: 'ASP Details',
    component: () => import(/* webpackChunkName: "aspportal-aspdetails" */ '../views/aspdetails.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'supplierdetails',
    name: 'Supplier Details',
    component: () => import(/* webpackChunkName: "aspportal-supplieroverview" */ '../views/supplieroverview.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'users',
    name: 'ASP Portal Users',
    component: () => import(/* webpackChunkName: "aspportal-users" */ '../views/users.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },
  {
    path: 'masterdetails',
    name: 'ASP Portal Master',
    component: () => import(/* webpackChunkName: "aspportal-masterdetails" */ '../views/masterdetails.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    },
  },

  {
    path: 'notfound',
    name: 'notfound',
    component: () => import(/* webpackChunkName: "admin-owners" */ '../views/PageNotFound.vue'),
    meta: {
      mainNavEnabled: isMainNavEnabled,
    }
  },
  
  
]
